<template>
  <v-container class="page">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row
      class="d-flex justify-center"
      v-show="!overlay"
    >
      <v-col
        cols="12"
        sm="6"
        md="6"
      >
        <v-card
          elevation="0"
          v-show="!overlay"
        >
          <v-toolbar
            light
            flat
          >
            <v-spacer />
            <div class="mt-10">
              <p class="text-center headline">
                <v-icon
                  color="#00ACDC"
                  class="mx-2"
                >
                  mdi-domain
                </v-icon>Company profile
              </p>
            </div>
            <div class="flex-grow-1" />
          </v-toolbar>
          <v-alert
            v-model="isEmpty"
            type="error"
            dismissible
          >
            Please complete all fields
          </v-alert>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-row>
                <v-col sm="12">
                  <v-text-field
                    outlined
                    hide-details
                    label="Client ID"
                    :rules="[v => !!v || 'Client ID is required']"
                    v-model="companyData.clientid"
                    required
                    disabled
                  />
                </v-col>
                <v-col sm="12">
                  <v-text-field
                    outlined
                    hide-details
                    label="Company name"
                    v-model="companyData.name"
                    disabled
                  />
                </v-col>
                <v-col sm="12">
                  <v-text-field
                    outlined
                    hide-details
                    label="Company email address"
                    v-model="companyData.metadata.company_email_address"
                  />
                </v-col>
                <v-col sm="12">
                  <v-divider />
                </v-col>
                <v-col
                  sm="12"
                  class="font-weight-medium"
                >
                  Booking configuration
                </v-col>
                <v-col sm="12">
                  <v-checkbox
                    dense
                    hide-details
                    v-model="companyData.metadata.overnight_booking"
                    label="Allow Overnight Booking"
                    color="success"
                  />
                </v-col>
                <v-col
                  sm="12"
                  v-if="companyData.metadata.overnight_booking"
                >
                  <v-checkbox
                    dense
                    hide-details
                    v-model="companyData.metadata.auto_approve_overnight_booking"
                    label="Auto Approve Overnight Booking"
                    color="success"
                  />
                </v-col>
                <v-col sm="12">
                  <v-checkbox
                    dense
                    hide-details
                    v-model="companyData.metadata.late_returning_key"
                    label="Notify Next Person of Late Key Return"
                    color="success"
                  />
                </v-col>
                <v-col sm="12">
                  <v-checkbox
                    dense
                    hide-details
                    v-model="companyData.metadata.restrict_booking"
                    label="Restrict Booking Time"
                    color="success"
                  />
                </v-col>
                <v-col
                  sm="12"
                  v-if="companyData.metadata.restrict_booking == true"
                >
                  <v-combobox
                    v-model="workingDaysObject"
                    :items="listWorkingDays"
                    label="Select Working Days"
                    multiple
                    chips
                    outlined
                    hide-details
                    item-text="name"
                    item-value="value"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="start"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="start"
                        label="Start working time"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        hide-details
                      />
                    </template>
                    <v-time-picker
                      v-if="modal"
                      v-model="start"
                      full-width
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(start)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-dialog
                    ref="dialog2"
                    v-model="modal2"
                    :return-value.sync="end"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="end"
                        label="End working time"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        hide-details
                      />
                    </template>
                    <v-time-picker
                      v-if="modal2"
                      v-model="end"
                      full-width
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="modal2 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog2.save(end)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col sm="12">
                  <v-select
                    :items="bufferItems"
                    :item-text="type => `${type} Minutes`"
                    label="Buffer booking time"
                    outlined
                    v-model="companyData.metadata.buffer_booking_time"
                    hide-details
                  />
                </v-col>
                <v-col sm="12">
                  <v-select
                    :items="minBookTimeItems"
                    :item-text="type => `${type} Minutes`"
                    label="Minimum booking time"
                    outlined
                    v-model="companyData.metadata.minimum_booking_time"
                    hide-details
                  />
                </v-col>
                <v-col sm="12">
                  <v-select
                    :items="defaultSelectionsVehicle"
                    label="Default Selection of Vehicle"
                    outlined
                    v-model="companyData.metadata.default_selection_vehicle"
                    :clearable="true"
                    hide-details
                  />
                </v-col>
                <v-col sm="12">
                  <v-divider />
                </v-col>
                <v-col
                  sm="12"
                  class="font-weight-medium"
                >
                  User configuration
                </v-col>
                <v-col sm="12">
                  <v-checkbox
                    dense
                    hide-details
                    v-model="companyData.metadata.no_need_rfid"
                    label="Bypass RFID Requirement"
                    color="success"
                  />
                </v-col>
                <v-col sm="12">
                  <v-checkbox
                    dense
                    hide-details
                    v-model="companyData.metadata.no_need_destination"
                    label="Hide Popular Destination"
                    color="success"
                  />
                </v-col>
                <v-col sm="12">
                  <v-checkbox
                    dense
                    hide-details
                    v-model="companyData.metadata.no_need_search_address"
                    label="Hide Search Address Destination"
                    color="success"
                  />
                </v-col>
                <v-col sm="12">
                  <v-divider />
                </v-col>
                <v-col
                  sm="12"
                  class="font-weight-medium"
                >
                  Azure AD SSO
                </v-col>
                <v-col sm="12">
                  <v-text-field
                    v-model="companyData.metadata.azure_jwks_uri"
                    label="Azure JWKS URI"
                    outlined
                    hide-details
                  />
                </v-col>
                <v-col sm="12">
                  <v-text-field
                    v-model="companyData.metadata.azure_tenant_id"
                    label="Azure Tenant ID"
                    outlined
                    hide-details
                  />
                </v-col>
                <v-col sm="12">
                  <v-text-field
                    v-model="companyData.metadata.azure_client_id"
                    label="Azure Client ID"
                    outlined
                    hide-details
                  />
                </v-col>
                <v-col sm="12">
                  <v-divider />
                </v-col>
                <v-col
                  sm="12"
                  class="font-weight-medium"
                >
                  Torus API
                </v-col>
                <v-col sm="12">
                  <v-text-field
                    v-model="companyData.metadata.provisioning_key"
                    label="Provisioning Key"
                    outlined
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="#00ACDC"
              dark
              block
              @click="checkValidation()"
            >
              UPDATE COMPANY PROFILE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog3"
      persistent
      max-width="600"
    >
      <v-card
        dark
        color="info"
        :loading="loadingBtn"
      >
        <template slot="progress">
          <v-progress-linear
            color="white"
            height="10"
            indeterminate
          />
        </template>
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to update
            this company profile?
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialog3 = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="updateCompanyProfile()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

export default {
  data: () => ({
    token: "",
    clientid: "",
    isEmpty: false,
    valid: false,
    workingDaysObject: [],
    companyData: {
      clientid: "",
      name: "",
      metadata: {
        company_email_address: "",
        working_time: {
          start: "",
          end: ""
        },
        buffer_booking_time: "",
        minimum_booking_time: "",
        azure_jwks_uri: "",
        azure_tenant_id: "",
        azure_client_id: "",
        provisioning_key: "",
        restrict_booking: false,
        overnight_booking: false,
        auto_approve_overnight_booking: false,
        no_need_rfid: false,
        no_need_destination: false,
        no_need_search_address: false,
        late_returning_key: false,
        working_day: []
      }
    },
    listWorkingDays: [
      { name: "Sunday", value: 0 },
      { name: "Monday", value: 1 },
      { name: "Tuesday", value: 2 },
      { name: "Wednesday", value: 3 },
      { name: "Thursday", value: 4 },
      { name: "Friday", value: 5 },
      { name: "Saturday", value: 6 }
    ],
    dialog3: false,
    modal: "",
    modal2: "",
    start: "",
    end: "",
    bufferItems: [
      "0",
      "5",
      "10",
      "15",
      "20",
      "25",
      "30",
      "35",
      "40",
      "45",
      "50",
      "55",
      "60"
    ],
    minBookTimeItems: [
      "0",
      "5",
      "10",
      "15",
      "20",
      "25",
      "30",
      "35",
      "40",
      "45",
      "50",
      "55",
      "60"
    ],
    defaultSelectionsVehicle: ["Low KM First"],
    loadingBtn: false,
    overlay: false,
  }),
  created() {
    this.token = this.$store.state.token;
    this.clientid = this.$store.state.clientid;
    this.loadCompany();
  },
  watch: {
    workingDaysObject(val) {
      if (!isEmpty(val)) {
        this.companyData.metadata.working_day = val.map(day => day.value);
      }
    },
    "companyData.metadata.restrict_booking"(val) {
      if (!val) {
        this.companyData.metadata.working_day = [];
      }
    }
  },
  methods: {
    loadCompany() {
      this.overlay = true;
      const { clientid } = this.$store.state;
      this.$store
        .dispatch("API_CALL", {
          $method: "get_company",
          $postData: {
            clientid
          }
        })
        .then(response => {
          this.setCompany(response.data.data);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getValueAsBoolean(value) {
      return value == 1 || value == '1' || value == 'true' || value == true ? 1 : 0;
    },
    setCompany(data) {
      this.companyData.clientid = data.clientid;
      this.companyData.name = data.name;
      if (data.metadata.length != 0) {
        this.companyData.metadata = { ...data.metadata };
        this.start = get(data, "metadata.working_time.start", "");
        this.end = get(data, "metadata.working_time.end", "");
        this.companyData.metadata.working_day = get(data.metadata, 'working_day', []);
        this.workingDaysObject = this.companyData.metadata.working_day.map(
          day => {
            return {
              name: this.listWorkingDays[day].name,
              value: day
            };
          }
        );
        this.companyData.metadata.overnight_booking = this.getValueAsBoolean(this.companyData.metadata.overnight_booking);
        this.companyData.metadata.auto_approve_overnight_booking = this.getValueAsBoolean(this.companyData.metadata.auto_approve_overnight_booking);
        this.companyData.metadata.no_need_rfid = this.getValueAsBoolean(this.companyData.metadata.no_need_rfid);
        this.companyData.metadata.no_need_destination = this.getValueAsBoolean(this.companyData.metadata.no_need_destination);
        this.companyData.metadata.no_need_search_address = this.getValueAsBoolean(this.companyData.metadata.no_need_search_address);
        this.companyData.metadata.restrict_booking = this.getValueAsBoolean(this.companyData.metadata.restrict_booking);
        this.companyData.metadata.late_returning_key = this.getValueAsBoolean(this.companyData.metadata.late_returning_key);
      } else {
        this.companyData.metadata.company_email_address = "";
        this.companyData.metadata.working_time.start = "";
        this.companyData.metadata.working_time.end = "";
        this.companyData.metadata.azure_jwks_uri = "";
        this.companyData.metadata.azure_tenant_id = "";
        this.companyData.metadata.azure_client_id = "";
        this.companyData.metadata.provisioning_key = "";
        this.companyData.metadata.working_day = [];
        this.companyData.metadata.restrict_booking = 0;
        this.companyData.metadata.overnight_booking = 0;
        this.companyData.metadata.auto_approve_overnight_booking = 0;
        this.companyData.metadata.no_need_rfid = 0;
        this.companyData.metadata.no_need_destination = 0;
        this.companyData.metadata.no_need_search_address = 0;
        this.companyData.metadata.late_returning_key = 0;
      }
    },
    updateCompanyProfile() {
      this.companyData.metadata.no_need_rfid = this.getValueAsBoolean(this.companyData.metadata.no_need_rfid);
      this.companyData.metadata.no_need_destination = this.getValueAsBoolean(this.companyData.metadata.no_need_destination);
      this.companyData.metadata.no_need_search_address = this.getValueAsBoolean(this.companyData.metadata.no_need_search_address);
      if (!this.companyData.metadata.hasOwnProperty("working_time")) {
        this.companyData.metadata.working_time = {};
      }
      this.companyData.metadata.working_time.start = this.start;
      this.companyData.metadata.working_time.end = this.end;
      this.companyData.metadata.restrict_booking = this.companyData.metadata
        .restrict_booking
        ? 1
        : 0;
      this.companyData.metadata.overnight_booking = this.companyData.metadata
        .overnight_booking
        ? 1
        : 0;
      this.companyData.metadata.auto_approve_overnight_booking = this.companyData.metadata
        .auto_approve_overnight_booking
        ? 1
        : 0;
      this.companyData.metadata.late_returning_key = this.companyData.metadata
        .late_returning_key
        ? 1
        : 0;
      this.loadingBtn = true;
      let payload = {
        metadata: this.companyData.metadata
      };
      this.$store.dispatch("UPDATE_COMPANY", payload).then(() => {
        this.loadingBtn = false;
        this.dialog3 = false;

        this.$swal({
          icon: "success",
          title: "Success update company profile."
        }).then(isConfirmed => {
          if (isConfirmed) {
            this.loadCompany();
          }
        });
      });
    },
    checkValidation() {
      if (this.$refs.form.validate()) {
        this.dialog3 = true;
      }
    }
  }
};
</script>
